import * as React from "react";
import { Box, Typography, Modal, Button } from "@mui/material";
import Datatable from "../../components/datatable/Datatable";
import columnsHeader, { paymentHistoryActionColumn } from "./ColumnsHeaderData";

const modalSx = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "100%", sm: "min(1120px, 96vw)" },
  maxWidth: "100%",
  maxHeight: { xs: "100dvh", sm: "90vh" },
  bgcolor: "background.paper",
  borderRadius: { xs: 0, sm: 2 },
  boxShadow: 24,
  p: { xs: 1, sm: 2 },
  display: "flex",
  flexDirection: "column",
  outline: "none",
  border: { xs: "none", sm: "1px solid" },
  borderColor: "divider",
  overflow: "hidden",
};

export default function PaymentHistoryModal({
  open,
  onClose,
  rowData,
  handleDelete,
}) {
  const safeRowData = Array.isArray(rowData) ? rowData : [];
  const mentor =
    safeRowData[0]?.full_name ||
    safeRowData[0]?.mentor_name ||
    safeRowData[0]?.email ||
    "";

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalSx} className="paymentHistoryModal">
        <Typography
          variant="h6"
          component="h2"
          sx={{ mb: 1, flexShrink: 0, fontWeight: 600 }}
        >
          Payment history{mentor ? ` — ${mentor}` : ""}
        </Typography>
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
            "& .datatable": {
              margin: 0,
              padding: { xs: "8px 10px 10px", sm: "14px 16px 16px" },
              flex: "0 0 auto",
              maxHeight: "none",
            },
          }}
        >
          {safeRowData.length === 0 ? (
            <Typography color="text.secondary" sx={{ py: 3, textAlign: "center" }}>
              No payment history found for this mentor.
            </Typography>
          ) : (
            <Datatable
              hideTitleBar
              pageTitle=""
              columnsData={columnsHeader.columnsData}
              actionColumn={paymentHistoryActionColumn(handleDelete)}
              rowData={safeRowData}
              showPagination
              rowsPerPage={10}
              autoHeight
              defaultSortModel={[{ field: "payment_date", sort: "desc" }]}
            />
          )}
        </Box>
        <Box
          sx={{
            mt: 1,
            display: "flex",
            justifyContent: "flex-end",
            flexShrink: 0,
          }}
        >
          <Button onClick={onClose} variant="outlined" size="small">
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
